import { useSheetBoundingBox } from "@/modes/alignment-modes-commons/align-to-cad-utils";
import { CadModelObject, PointCloudObject } from "@/object-cache";
import { IElementGenericImgSheet } from "@faro-lotv/ielement-types";
import { useMemo } from "react";
import { Box3, Vector3 } from "three";
import { use3DmodelsBoundingBox } from "./use-object-bounding-box";

/**
 *
 * @param pointCloud The point cloud that should be contained in the box
 * @param cad The CAD model that should be contained in the box
 * @param sheets The list of visible sheets that should be contained in the box
 * @returns The bounding box containing all the argument objects
 */
export function useClippableObjectsBox(
  pointCloud: PointCloudObject | null,
  cad: CadModelObject | null | Error,
  sheets: IElementGenericImgSheet[],
): Box3 {
  const modelsBox = use3DmodelsBoundingBox(pointCloud, cad);
  const sheetBBox = useSheetBoundingBox(sheets);

  return useMemo(() => {
    const result = modelsBox.clone();
    const sheetSz = sheetBBox.getSize(new Vector3());
    const modelsSz = modelsBox.getSize(new Vector3());
    // do not trust absurd sheet sizes
    if (sheetSz.x < modelsSz.x * 10 && sheetSz.z < modelsSz.z * 10) {
      result.union(sheetBBox);
    }
    return result;
  }, [modelsBox, sheetBBox]);
}
